import HexController from 'controllers/hex_controller';

export default class extends HexController {
  static targets = ['usage', 'guidance', 'usageButton'];

  connect() {
    this.usageButtonTarget.addEventListener('click', () => {
      this.showUsage();
    });
  }

  showUsage() {
    this.usageTarget.classList.remove('hidden');
    this.guidanceTarget.classList.add('hidden');
    this.usageButtonTarget.classList.add('hidden');
  }

  showGuidance() {
    this.usageTarget.classList.add('hidden');
    this.guidanceTarget.classList.remove('hidden');
    this.usageButtonTarget.classList.remove('hidden');
  }
}